import script from "./m-library-popular-tags.vue?vue&type=script&setup=true&lang=js"
export * from "./m-library-popular-tags.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__